export default __webpack_public_path__ + "static/media/330_private01-es-mobile.26649639.png";